/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class InternalVisDefinitionsAPI
 * @hideconstructor
 * @classdesc Represents the API to access the visualization definitions that are registered in the dashboard application.
 */

define([], () => {
	class InternalVisDefinitionsAPI {

		/**
		 * @function InternalVisDefinitionsAPI#getRawDefinition
		 * @description Return an object with the raw visualization definitions.
		 * @public
		 *
		 * @return {Object} visualizations definition object
		 *
		 */
		getRawDefinition() {}

		/**
		 * @function InternalVisDefinitionsAPI#getAll
		 * @description Return all the raw visualization definitions.
		 * @public
		 *
		 * @return {Object[]} list of visualizations definition objects
		 *
		 */
		getAll(){}

	}
	return InternalVisDefinitionsAPI;
});
